<template>
  <el-dialog
    class="news-editor"
    :visible="newsEditorVisible"
    @close="closeEditor"
    width="90%"
  >
    <el-form
      :model="newsForm"
      :rules="rules"
      ref="newsForm"
      label-width="100px"
      class="news-ruleForm"
    >
      <el-form-item label="標題" prop="short_description">
        <el-input v-model="newsForm.short_description"></el-input>
      </el-form-item>
      <el-form-item label="分類" prop="type">
        <el-radio-group v-model="newsForm.type">
          <el-radio-button label="course">課程</el-radio-button>
          <el-radio-button label="activity">活動</el-radio-button>
          <el-radio-button label="rank">榜單</el-radio-button>
          <el-radio-button label="private_school">升私中</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="發布日期" prop="publish_date">
        <el-date-picker
          v-model="newsForm.publish_date"
          type="date"
          value-format="timestamp"
          placeholder="選擇日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="縮圖" prop="thumbnail">
        <el-upload
          class="thumbnail-uploader"
          accept="image/*"
          :action="actionURL"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleThumbnailSuccess"
          :before-upload="beforeThumbnailUpload"
          :on-error="handleError"
        >
          <img
            v-if="newsForm.thumbnail"
            :src="newsForm.thumbnail"
            class="thumbnail-img"
          />
          <i v-else class="el-icon-plus thumbnail-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="內容">
        <tinymce
          v-model="newsForm.content"
          model-events="change"
          :init="initOptions"
          tinymce-script-src="/tinymce/tinymce.min.js"
        />
      </el-form-item>
    </el-form>
    <template v-if="editor">
      <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        class="tinymce-image"
      >
        <tinymce-image @success="uploadImageSuccess" />
      </el-dialog>
    </template>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEditor">取 消</el-button>
      <el-button type="primary" @click="confirm">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["newsEditorVisible", "newsForm", "isCreate"],
  data() {
    return {
      dialogVisible: false,
      editor: undefined,
      rules: {
        short_description: [
          { required: true, message: "請輸入標題", trigger: "blur" }
        ],
        type: [{ required: true, message: "請選擇分類", trigger: "blur" }],
        publish_date: [
          { required: true, message: "請選擇發布日期", trigger: "blur" }
        ],
        thumbnail: [{ required: true, message: "請上傳縮圖", trigger: "blur" }]
      },
      initOptions: {
        plugins:
          "autoresize preview fullpage importcss searchreplace autolink autosave directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons",
        toolbar: [
          "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | insertImage | pagebreak | charmap emoticons | fullscreen preview"
        ],
        language: "zh-Hant",
        language_url: "/tinymce/langs/zh-Hant.js",
        font_size_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt 48pt",
        font_formats:
          "思源黑體=Noto Sans TC;Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
        content_css: "/tinymce/css/index.css",
        link_class_list: [
          { title: "一般", value: "" },
          { title: "紅色方形按鈕", value: "tinymce-red-square-btn" },
          { title: "綠色方形按鈕", value: "tinymce-green-square-btn" },
          { title: "藍色方形按鈕", value: "tinymce-blue-square-btn" },
          { title: "紅色圓形按鈕", value: "tinymce-red-circle-btn" },
          { title: "綠色圓形按鈕", value: "tinymce-green-circle-btn" },
          { title: "藍色圓形按鈕", value: "tinymce-blue-circle-btn" }
        ],
        min_height: 500,
        statusbar: false,
        init_instance_callback: this.onEditorInit,
        setup: editor => {
          editor.on("init", () => {
            this.loading = false;
            this.$emit("loaded");
          });
          editor.ui.registry.addButton("insertImage", {
            icon: "image",
            text: "插入圖片",
            tooltip: "插入圖片",
            onAction: () => {
              this.dialogVisible = true;
            }
          });
        }
      }
    };
  },
  computed: {
    actionURL: () => process.env.VUE_APP_API_UPLOAD,
    headers() {
      return {
        Authorization: localStorage.getItem("token")
      };
    }
  },
  methods: {
    handleThumbnailSuccess(res) {
      this.newsForm.thumbnail = res.Location;
    },
    beforeThumbnailUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("圖片大小不能超過 5MB!");
      }
      return isLt5M;
    },
    handleError(e) {
      let result = JSON.parse(e.message || "{}");
      this.loading = false;
      this.$message.error(`圖片上傳失敗 ${result.message || ""}`);
    },
    uploadImageSuccess(imgUrl) {
      this.dialogVisible = false;
      if (this.editor) this.editor.insertContent(`<img src="${imgUrl}">`);
    },
    onEditorInit(editor) {
      this.editor = editor;
    },
    closeEditor() {
      this.$emit("update:newsEditorVisible", false);
    },
    confirm() {
      this.$refs["newsForm"].validate(async valid => {
        if (valid) {
          this.$emit("saveNews", this.newsForm);
        } else {
          return false;
        }
      });
    }
  },
  created() {},
  mounted() {},
  components: {
    Tinymce: () => import("@tinymce/tinymce-vue"),
    TinymceImage: () => import("./TinymceImage")
  }
};
</script>

<style lang="scss">
.news-editor {
  .news-ruleForm {
    padding-right: 50px;
  }

  .thumbnail-img {
    width: 175px;
    display: block;
  }

  .tinymce-image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .thumbnail-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .thumbnail-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .thumbnail-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 175px;
    height: 175px;
    line-height: 175px;
    text-align: center;
  }
}

.tox-notifications-container {
  display: none !important;
}

.tox-silver-sink {
  z-index: 9999 !important;
}

.tox-promotion {
  display: none;
}
</style>
